import { defineStore } from "pinia";
import { constants } from "@/constants";
import { useCartStore } from "@/store/cart";
import { useSessionStore } from "@/store/session";
import MultiLocalStorage from "@/services/multiLocalStorage";
import CartService from "@/services/cart";

export const useOrderHistoryStore = defineStore("orderHistory", {
  state: () => ({
    _lastUpdate: null,
    _orderHistory: [],
  }),
  getters: {
    orderHistory: (state) => {
      MultiLocalStorage.checkCleanOrderHistory();

      if (state._orderHistory.length === 0) {
        const orderHistory = MultiLocalStorage.get(
          constants.ECOM_ORDER_HISTORY,
          window?.globalConfig?.domainId,
        );
        return orderHistory ? orderHistory : [];
      }

      return state._orderHistory;
    },
    lastUpdate: (state) => state._lastUpdate,
  },
  actions: {
    addStepToHistory() {
      MultiLocalStorage.checkCleanOrderHistory();

      if (this.orderHistory.length > 0) {
        const lastHistoryItem = this.orderHistory[this.orderHistory.length - 1];
        if (lastHistoryItem.step) {
          lastHistoryItem.step += 1;
        } else {
          lastHistoryItem.step = 1;
        }
      }

      this._orderHistory = this.orderHistory;

      MultiLocalStorage.set(
        constants.ECOM_ORDER_HISTORY,
        window?.globalConfig?.domainId,
        this.orderHistory,
      );

      this._lastUpdate = new Date();
    },
    addOrderToHistory(cart, order, step) {
      MultiLocalStorage.checkCleanOrderHistory();

      if (!order.sessionIdentifier) {
        order.sessionIdentifier = useSessionStore().session.identifier;
      }

      const existingHistoryItem = this.orderHistory.find(
        (i) => i.order.externalOrderId === order.externalOrderId,
      );

      const minifiedCart = CartService.minifyCartForHistory(cart);

      if (!existingHistoryItem) {
        this.orderHistory.push({ order, cart: minifiedCart, step });
      } else {
        Object.assign(existingHistoryItem, { order, cart: minifiedCart });
      }

      this.orderHistory.splice(0, this.orderHistory.length - 4); // limiting history to the 4 last orders

      this._orderHistory = this.orderHistory;

      MultiLocalStorage.set(
        constants.ECOM_ORDER_HISTORY,
        window?.globalConfig?.domainId,
        this.orderHistory,
      );

      this._lastUpdate = new Date();
    },
    removeRetryOrders() {
      MultiLocalStorage.checkCleanOrderHistory();

      if (this.orderHistory.length > 0) {
        this._orderHistory = this.orderHistory.filter((i) => !i.order.isRetry);
      }

      MultiLocalStorage.set(
        constants.ECOM_ORDER_HISTORY,
        window?.globalConfig?.domainId,
        this.orderHistory,
      );

      this._lastUpdate = new Date();
    },
  },
});
